import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { getTranslationSheet } from '@/api/google/sheet.js'
const lang_list = ['tw', 'en'];
Vue.use(VueI18n);
let messages = {};
messages = { ...messages}
let lang = localStorage.getItem('language') || 'TW';
const i18n = new VueI18n({
    locale: lang,
    messages
});
async function loadLanguage(lang) { 
  const messages = await getTranslationSheet(lang);
  i18n.setLocaleMessage(lang, messages)
  i18n.locale = lang
  document.querySelector('html').setAttribute('lang', lang);
  localStorage.setItem('language', lang)
}
i18n.loadLanguage = loadLanguage;
(() => {
  loadLanguage(lang);
})();
export default i18n